import { handleURLForWKT } from "../handleURL";
import { WKTInputControl } from "../controls/WKTInputControl";
import { getWKTLayer } from "../layers/WKTLayer";
import {
  getWKTToggleFromURL,
  registerWKTControl,
} from "../state/URLStateManager";

export function addWKTLayerAndControl(map, target, view, azureLoginControl) {
  const wktInputControl = new WKTInputControl({
    target: target,
  });
  const wktLayer = getWKTLayer(wktInputControl, view, azureLoginControl);
  map.addLayer(wktLayer);
  map.addControl(wktInputControl);
  handleURLForWKT(wktInputControl);

  // Restore wktToggle from URL (default is true; only stored when false)
  if (!getWKTToggleFromURL()) {
    wktInputControl.set("wktToggle", false);
  }

  registerWKTControl(wktInputControl);
  return [wktLayer, wktInputControl];
}
